import React, { createContext, useState, useContext, ReactNode } from 'react';

interface UserType {
  id: number;
  name: string;
}

interface UserInfo {
  id: string;
  firstName: string;
  lastName: string;
  userTypeId: number;
  phone: string | null;
  email: string | null;
  isActived: boolean;
  username: string;
  image: string | null;
  createDate: string;
  userType: UserType;
}

interface UserContextProps {
  user: UserInfo | null;
  setUser: (user: UserInfo) => void;
}

const UserContext = createContext<UserContextProps | undefined>(undefined);

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserInfo | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
